// Add project specific javascript code and import of additional bundles here:
import {fieldRegistry} from 'sulu-admin-bundle/containers';
import {formToolbarActionRegistry} from 'sulu-admin-bundle/views/Form';

import AiEditor from './fields/AiEditor';
import Hint from './fields/Hint';
import OpeningHours from './fields/OpeningHours';
import ProductQRCode from './fields/ProductQRCode';
import SortableValues from './fields/SortableValues';
import PERSPEQTIVEUpdateFormStoreToolbarAction from "./views/Form/toolbarActions/PERSPEQTIVEUpdateFormStoreToolbarAction";
import PERSPEQTIVETypeToolbarAction from "./views/Form/toolbarActions/PERSPEQTIVETypeToolbarAction";
import PERSPEQTIVEDeleteToolbarAction from "./views/Form/toolbarActions/PERSPEQTIVEDeleteToolbarAction";
import PERSPEQTIVESaveToolbarAction from "./views/Form/toolbarActions/PERSPEQTIVESaveToolbarAction";
import PERSPEQTIVEPublishToolbarAction from "./views/Form/toolbarActions/PERSPEQTIVEPublishToolbarAction";
import PERSPEQTIVESetUnpublishedToolbarAction from "./views/Form/toolbarActions/PERSPEQTIVESetUnpublishedToolbarAction";

fieldRegistry.add('ai_editor', AiEditor);
fieldRegistry.add('opening_hours', OpeningHours);
fieldRegistry.add('hint', Hint);
fieldRegistry.add('product_qrcode', ProductQRCode);
fieldRegistry.add('sortable_values', SortableValues);

formToolbarActionRegistry.add('perspeqtive.sulu_admin.update_form_store', PERSPEQTIVEUpdateFormStoreToolbarAction);
formToolbarActionRegistry.add('perspeqtive.sulu_admin.type', PERSPEQTIVETypeToolbarAction);
formToolbarActionRegistry.add('perspeqtive.sulu_admin.delete', PERSPEQTIVEDeleteToolbarAction);
formToolbarActionRegistry.add('perspeqtive.sulu_admin.save', PERSPEQTIVESaveToolbarAction);
formToolbarActionRegistry.add('perspeqtive.sulu_admin.publish', PERSPEQTIVEPublishToolbarAction);
formToolbarActionRegistry.add('perspeqtive.sulu_admin.set_unpublished', PERSPEQTIVESetUnpublishedToolbarAction);